window.clientBridge = new XBridge({});
import { setToken, removeToken } from "./token";
import store from './store' //使用vuex状态管理
import { getCommonInfoB } from '@/utils/birdge';
import { isInNewJsBridgeApp, isInAppB, isInAppC } from './index';
import axDsbridge from '@anxin/dsbridge';
import { jsbNameObj } from './dsbridgeName.js';

if (isInNewJsBridgeApp()) {
  window.clientBridge = {
    callBridge: (options) => {
      const { name, params, successCallback, failCallback } = options;
      const isAxApp = Boolean(
        window._cjDsBridge ||
          window._cjDswk ||
          navigator.userAgent.indexOf("_cjDsBridge") != -1
      );
      // 如果在含有新版的Dsbridge的App里，则使用新的方法
      if (isAxApp) {
        const axNewName = jsbNameObj[name] || name;
        // 在新改版的 dsbridge 版本中，非新增的（原老方法[axNewName !== name]），B/C端不能调用非自己端的方法
        if (axNewName !== name && isInAppB() && name.indexOf('CloudWorkbenchJsApi.setDocTitle') === -1 && name.indexOf('CloudWorkbenchJsApi') === -1) {
          console.log(name + " fail:在 B 端调用 C 端方法");
          failCallback && failCallback();
          return
        }
        if (axNewName !== name && isInAppC() && name.indexOf('CloudWorkbenchJsApi.setDocTitle') === -1 && name.indexOf('CloudWorkbenchJsApi') > -1) {
          console.log(name + " fail:在 C 端调用 B 端方法");
          failCallback && failCallback();
          return
        }
        axDsbridge.call(axNewName, params || {}, res => {
          console.log(axNewName + " success", res);
          if (res.status === 1) {
            successCallback && successCallback(res.data);
          } else {
            console.log(axNewName + " fail:", res);
            failCallback && failCallback(res);
          }
        });
      } else {
        console.log(" fail: it's not in App");
        failCallback && failCallback();
      }
    }
  }
}

export default {
  install: function (Vue) {
    Vue.prototype.isWX = navigator.userAgent.match(/MicroMessenger/i)
    /**
     * 检测用户是否登录
     * @param loginHandle   登录时的回调
     */
    // 老方法逻辑有问题，新增的用新的
    Vue.prototype.getStaffInfo = function (successHandle, failureHandle) {
      clientBridge.callBridge({
        desc: "判断用户是否已经登录",
        name: "getUserInfo",
        params: null,
        successCallback: (isLogin) => {
          // console.log(isLogin.token, 'getUserInfo');
          setToken(isLogin.token);
          store.commit('SET_LOG_IN_STATIC', true);
          localStorage.setItem('merchantNo', isLogin.merchantNo);
          store.commit('SET_MERCHANT_NO', isLogin.merchantNo)
          successHandle && successHandle()
        },
        failCallback: () => {
          failureHandle && failureHandle();
        }
      });
    };
    // 为了解决sentry this.getUserInfo is not a function
    Vue.prototype.getUserInfo = function(successHandle, failureHandle) {
      clientBridge.callBridge({
        desc: "判断用户是否已经登录",
        name: "getUserInfo",
        params: null,
        successCallback: isLogin => {
          setToken(isLogin.token);
          store.commit("SET_LOG_IN_STATIC", true);
          localStorage.setItem("merchantNo", isLogin.merchantNo);
          store.commit("SET_MERCHANT_NO", isLogin.merchantNo);
          failureHandle && failureHandle();
        },
        failCallback: () => {
          failureHandle && failureHandle();
        }
      });
    };

    Vue.prototype.checkLogin = function (successHandle, failureHandle) {
      clientBridge.callBridge({
        desc: "判断用户是否已经登录",
        name: "getUserInfo",
        params: null,
        successCallback: (isLogin) => {
          setToken(isLogin.token);
          store.commit('SET_LOG_IN_STATIC', true);
          localStorage.setItem('merchantNo', isLogin.merchantNo);
          store.commit('SET_MERCHANT_NO', isLogin.merchantNo)
          failureHandle && failureHandle()
        },
        failCallback: () => {
          failureHandle && failureHandle();
        }
      });
    };
    /**
     *退出登录
     */
    Vue.prototype.loginOut = function () {
      clientBridge.callBridge({
        name: 'loginOut',
        params: null,
        successCallback: function () {
          store.commit('SET_LOG_IN_STATIC', false)
          removeToken();
          location.reload();
          localStorage.clear();
          sessionStorage.clear();
        },
        failCallback: () => {

        }
      })
    };
    //调取app扫脸拍照
    Vue.prototype.faceRecoginzer = function (params, successHandle) {
      clientBridge.callBridge({
        name: 'startFaceRecoginzer',
        params: params,
        successCallback: function (res) {
          successHandle && successHandle(res)
        },
      })
    };
    /**
     *更新merchantNo
     */
    Vue.prototype.setMerchantNoFromH5 = function (merchantNo) {
      clientBridge.callBridge({
        name: 'switchMerchant',
        params: merchantNo,
        successCallback: function () {},
        failCallback: function () {}
      });
    };
    /**
     *同知领取成功
     */
    Vue.prototype.receiveSalary = function () {
      clientBridge.callBridge({
        name: 'receiveSalary',
        params: {},
        successCallback: function () {},
        failCallback: function () {}
      });
    };

    /**
     *下载图片
     */
    Vue.prototype.downloadImage = function (url) {
      clientBridge.callBridge({
        name: 'downloadImage',
        params: url,
        successCallback: function () {},
        failCallback: function () {}
      });
    };

    /**
     *更新权限列表
     */
    Vue.prototype.switchCompany = function (data) {
      clientBridge.callBridge({
        name: 'switchMerchantGeneralServers',
        params: data,
        successCallback: function () {},
        failCallback: function () {}
      });
    };

    /**
     *获取版本号
     */
    Vue.prototype.getClientVersion = function (successHandle, failureHandle) {
      clientBridge.callBridge({
        name: 'getAppVersion',
        params: {},
        successCallback: function (res) {
          successHandle && successHandle(+res.version.replace(/\./g, ""), res.version);
          localStorage.setItem('AppVersion', res.version);
        },
        failCallback: function () {
          failureHandle && failureHandle();
          // 调用B端获取版本号的bridge方法
          getCommonInfoB({}, successHandle, failureHandle)
        }
      });
    };
    //跳转消息通知页面
    Vue.prototype.toNotificationPage = function (successHandle, failureHandle) {
      clientBridge.callBridge({
        name: 'toNotificationPage',
        params: {},
        successCallback: function (res) {

        },
        failCallback: function () {

        }
      });
    };
    /**
     * 新建WebView 打开页面
     * @param urlStr
     */
    Vue.prototype.openNewWebView = function (urlStr) {
      var tempUrl = "";
      if (urlStr.match(/(http)|(file)|(saas)/i)) {
        clientBridge.callBridge({
          name: "openNewNative",
          params: {
            "url": urlStr
          },
          successCallback: function () {
            tempUrl = urlStr.split("#");
            tempUrl[0] = tempUrl[0] + (tempUrl[0].match(/\?/) ? "&" : "?") + "openType=newNative";
            urlStr = tempUrl.length > 1 ? tempUrl.join("#") : tempUrl[0];
            setTimeout(() => {
              window.location.href = tempUrl;
            }, 100);
          },
          failCallback: function () {
            var href = location.href;
            tempUrl = (href.match(/\?/) ? href.split("?")[0] : href.split("#")[0]);
            if (urlStr.indexOf("&") == 0) {
              urlStr = urlStr.replace("&", "");
              tempUrl += "?";
            }
            setTimeout(() => {
              window.location.href = tempUrl + '#/' + urlStr;
            }, 100);
          }
        })
      } else {
        var href = location.href;
        tempUrl = (href.match(/\?/) ? href.split("?")[0] : href.split("#")[0]);
        if (urlStr.indexOf("&") == 0) {
          urlStr = urlStr.replace("&", "");
          tempUrl += "?";
        }
        clientBridge.callBridge({
          name: "openNewNative",
          params: {
            "url": tempUrl + urlStr
          },
          successCallback: function () {
            setTimeout(function () {
              window.location.href = tempUrl + (tempUrl.match(/\?/) ? "" : "?") + "openType=newNative" +
                (urlStr.split("#")[0] == "" ? "" : "&") + urlStr;
                
            }, 100);
          },
          failCallback: function () {
            setTimeout(function () {
              window.location.href = tempUrl + '#/' + urlStr;
            }, 100);
          }
        })
      }
    };
    /**
     * 新建WebView 直接打开页面
     * @param urlStr
     */
     Vue.prototype.openDirectlyNewWebView = function (urlStr) {
      if (urlStr) {
        clientBridge.callBridge({
          name: "openNewNative",
          params: {
            "url": urlStr
          },
          successCallback: function () {
            setTimeout(() => {
              window.location.href = urlStr;
            }, 100);
          },
          failCallback: function () {}
        })
      }
    };
    /**
     * 关闭当前webview
     */
    Vue.prototype.finishWebAct = function (successHandle, failureHandle) {
      clientBridge.callBridge({
        name: "finishWebAct",
        params: {},
        successCallback: function () {
          successHandle && successHandle()
        },
        failCallback: function () {
          failureHandle && failureHandle();
          sessionStorage.setItem('needGoBack', true)
        }
      });
    };
    /**
     *
     * @param 获取url参数
     * @returns 值
     */
    Vue.prototype.getQueryString = function (name) {
      let match = undefined
      let href = window.location.href
      let index = href.indexOf('?')
      if (index > -1 && href.match(new RegExp(name, 'i'))) {
        let queryStr = href.slice(index + 1).replace(/#([^?]+)/g, '')
        let matches = queryStr.match(new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'))
        match = matches && matches[2] ? decodeURIComponent(matches[2]) : undefined
      }
      return match
    };
    /**
     * 初始化微信配置
     */
    Vue.prototype.getWeiXinLocation = function (configs, fn) {
      try {
        if (typeof wx != 'undefined') {
          wx.config({
            debug: false,
            appId: configs.appId, // 必填，公众号的唯一标识
            timestamp: configs.timestamp, // 必填，生成签名的时间戳
            nonceStr: configs.noncestr, // 必填，生成签名的随机串
            signature: configs.signature, // 必填，签名，见附录1
            jsApiList: [
              'getLocation' //地理信息
            ]
          });
          wx.ready(function () {
            wx.getLocation({
              type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function (res) {
                // let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                // let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                // let speed = res.speed; // 速度，以米/每秒计
                // let accuracy = res.accuracy; // 位置精度
                fn && fn(res)
              },
              fail: function () { //调用失败
                fn && fn({
                  myErrorType: 'fail'
                })
              },
              cancel: function () { //用户取消
                fn && fn({
                  myErrorType: 'cancel'
                })
              }
            })
            wx.error(function (res) {
              // alert(res.errMsg)
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            })
          })
        }
      } catch (e) {}

    }
    //腾讯点位
    Vue.prototype.setTencent = function (name) {
      try {
        MtaH5 && MtaH5.clickStat(name)
      } catch (e) {

      }
    }
    // 提现客户端埋点
    Vue.prototype.cashOut = function () {
      clientBridge.callBridge({
        name: 'cashOut',
      })
    }
    //获取用户支付宝的绑定情况
    Vue.prototype.getBindState = function () {
      this.$http.post('/api/customer/account/aliPayOrBankBinding').then(res => {
        if (!res.errorCode && res.results) {
          this.$store.commit('SET_SOME_BIND_STATIC', !!(res.results.alipayBinding || res.results.bankBinding))
          this.$store.commit('SET_ALI_ACCOUNT', res.results.aliAccount || '')
          this.$store.commit("SET_ALIPAYDATA", res.results)
        }
      })
    }
    //绑定微信
    Vue.prototype.bindWechat = function(params, callback) {
      this.$http.post("/api/app/account/wx/bind", params).then(res => {
        if (res && !res.errorCode) {
          this.showToast('绑定成功')
          callback && callback();
        } else {
          this.showToast("微信绑定失败");
        }
      });
    };

    /**
     * 禁止冒泡事件
     */
    Vue.directive('touchPrevent', {
      inserted(el) {
        el.addEventListener('touchmove', function (ev) {
          ev.stopPropagation()
          ev.stopImmediatePropagation()
        })
      }
    })
    /**
     * 下拉加载 兼容弹跳
     */
    Vue.directive('bottomLoad', {
      inserted(el, binding) {
        let isBottomLoad = !binding.value.isNotBottomLoad;
        let isTopRefresh = binding.value.isTopRefresh || false
        if (isBottomLoad) {
          let addData = binding.value.handle
          let distance = binding.value.distance
          el.style.height = window.innerHeight - el.getBoundingClientRect().top + 'px'
          el.style.overflowX = 'hidden'
          el.style.overflowY = 'scroll'
          el.style.webkitOverflowScrolling = 'touch'
          el.addEventListener('scroll', () => {
            if (el.scrollTop + el.clientHeight + distance >= el.scrollHeight) {
              if (window.bottomLoadTimer) {
                clearTimeout(window.bottomLoadTimer)
              }
              window.bottomLoadTimer = setTimeout(function () {
                addData()
                delete window.bottomLoadTimer
              }, 300)
            }
          })
          setTimeout(function () {
            if (el.clientHeight >= el.scrollHeight) {
              addData()
            }
          }, 500)
        }
        /**
         * 如果开启上拉刷新
         */
        if (isTopRefresh) {
          let refreshFn = binding.value.refreshFn
          let startY = 0 //手指触摸最开始的Y坐标
          let change = 0 //滑动的距离
          el.addEventListener('touchstart', (e) => {
            e.stopPropagation()
            startY = e.touches[0].pageY
            el.style.transition = 'all  0s'
            change = 0

          })
          el.addEventListener('touchmove', (e) => {
            e.stopPropagation()

            change = e.touches[0].pageY - startY
            if (el.scrollTop <= 0 && change > 0) {
              e.preventDefault()
            }
            if (!el.scrollTop && change > 0 && (change < 50)) {
              el.style.transform = 'translateY(' + change + 'px)'
            }
          })

          el.addEventListener('touchend', (e) => {
            e.stopPropagation()
            if (el.scrollTop <= 0) {
              el.style.transition = 'all ease 0.5s'
              el.style.transform = 'translateY(0)'
              if (change > 20) {
                refreshFn && refreshFn()
              }
              change = 0
            } else {
              el.style.transform = 'translateY(0)'
            }
          })
        }
      }
    })
    /**
     * 钱格式转换格式
     */
    Vue.filter('money', (money) => {
      return money
    })
    /**
     * 银行卡号转换格式
     */
    Vue.filter('bank', input => {
      // let temp = String(input).split('');
      // let gap = 4;
      // while (gap < temp.length) {
      //   temp.splice(gap, 0, ' ');
      //   gap += 6;
      // }
      // return temp.join('').trim()
      return input
    })
    /**
     * 设置下方的高度
     */
    Vue.directive('growHeight', {
      inserted(el) {
        el.style.height = window.innerHeight - el.getBoundingClientRect().top + 'px'
      }
    })

    // 获取用户当前地理位置
    Vue.prototype.getUserLocation = function (successHandle, failureHandle) {
        console.log('调用获取用户地理位置getLocation方法')
        clientBridge.callBridge({
          desc: '获取用户当前地理位置',
          name: 'getLocation',
          successCallback: res => {
            if (res.status !== 'noPremission') {
              successHandle && successHandle(res)
            }
          },
          failCallback: () => {
            console.log('获取用户当前地理位置失败！！！');
            failureHandle && failureHandle()
          }
        })
      },

      // 客户端打点方法(风控打点)
      Vue.prototype.saasTrackEvent = function (data, successHandle, failHandle) {
        clientBridge.callBridge({
          desc: '客户端打点方法-用于补卡',
          name: 'saasTrackEvent',
          params: data,
          successCallback: () => {
            successHandle && successHandle()
          },
          failCallback: () => {
            failHandle && failHandle()
          }
        })
      }

    // showFinalSalary 显示尾薪，客户端去显示尾薪弹框
    Vue.prototype.showFinalSalary = (data, successHandle, failHandle) => {
      clientBridge.callBridge({
        desc: '显示尾薪',
        name: 'showFinalSalary',
        params: data,
        successCallback: () => {
          successHandle && successHandle()
        },
        failCallback: () => {
          failHandle && failHandle()
        }
      })
    }

    // 告诉客户端，申诉成功，客户端去刷新客户端的页面
    Vue.prototype.appealSuccess = (data, successHandle, failHandle) => {
      clientBridge.callBridge({
        desc: '告诉客户端，申诉成功',
        name: 'appealSuccess',
        params: data,
        successCallback: () => {
          successHandle && successHandle()
        },
        failCallback: () => {
          failHandle && failHandle()
        }
      })
    }

    // // 发薪，考勤审核（拒绝，通过）之后，告诉客户端刷新页面
    // Vue.prototype.bdgUpdateCheckList = (data, successHandle, failHandle) => {
    //   clientBridge.callBridge({
    //     name: 'CloudWorkbenchJsApi.updateCheckList',
    //     params: null
    //   })
    // }
  }
}
